export const REVOKING_TYPES = {
  ALL_SIGNATURES: "ALL_SIGNATURES",
  OWN_SIGNATURE: "OWN_SIGNATURE",
};

export const BUTTON_TITLES = {
  ALL_SIGNATURES: "REVOKING_SIGNATURE_BUTTON_TITLES.ALL_SIGNATURES",
  OWN_SIGNATURE: "REVOKING_SIGNATURE_BUTTON_TITLES.OWN_SIGNATURE",
};

export const MS_SETTINGS_PERMISSIONS = {
  ALL_SIGNATURES: "ms-settings.enable_functionality.revoke_all_signatures",
  OWN_SIGNATURE: "ms-settings.enable_functionality.revoke_own_signature",
};

export const TRUE = "true";
